import React, { useState, useEffect } from "react"
import GenericRoadEvent from './RoadEvents/GenericRoadEvent';
import CrossingEvent from './CrossingEvents/CrossingEvent';
import CurvedRoadEvent from './CrossingEvents/CurvedRoadEvent';

export default function Road(props) {
  //const [motionFinished, setMotionFinished] = useState(false);
  const [animatingClasses, setAnimatingClasses] = useState([])
  const [eventFrame, setEventFrame] = useState(0);
  const [frameTriggerIndex, setFrameTriggerIndex] = useState(0);
  const [completedRoadEvents, setCompletedRoadEvents] = useState([]);
  const [positionalFrameTriggers, setPositionalFrameTriggers] = useState([]);
  const showDistance = document.location.href.indexOf('showDistance') > -1;
 




  useEffect(() => {
    setCompletedRoadEvents([...(props.roadEvents || []).map(e => false)])
    console.log("props.roadEvents" , props.roadEvents.length);
    if(props.roadEvents.length === 0){
      console.log("NO ROAD EVENTS so ROAD is CLEAR" );
      props.roadClear()
    }
    if(props.curvedRoadData !== undefined){
      setPositionalFrameTriggers([...new Array(55)].map((e,i) => props.curvedRoadData.positionalFrameStart + (i*90)))
    }
  }, [])

  useEffect(() => {    
    if (props.curvedRoadData !== undefined && props.position > positionalFrameTriggers[frameTriggerIndex]) {     
        setEventFrame(eventFrame+1);
        setFrameTriggerIndex(frameTriggerIndex+1);
    }
}, [props.position])

useEffect(()=> {
  console.log("completedRoadEvents.length" , completedRoadEvents.length);
  console.log("completedRoadEvents.filter(e => e === false).length" , completedRoadEvents.filter(e => e === false).length);
  console.log("completedRoadEvents" , completedRoadEvents);
  if(completedRoadEvents.length > 0 && completedRoadEvents.filter(e => e === false).length === 0){
    console.log("call props.roadClear()" );
    props.roadClear()
  } 
}, [completedRoadEvents])

  const getYOffset = offsetSpeed => {
    let limit = 8;
    if (props.position * offsetSpeed < limit) {
      return props.position * offsetSpeed;
    }

    return limit;
  };

  const markPoints = () => {

    let points = [];
    for (let i = -50000; i < 50000; i++) {
      points.push(i);
    }

    return points.map(i => {
      if (i % 50 === 50 - 1) {
        return <div
            key={i}
            className={`point`}
            style={{
              transform: `translate3d(50%, ${parseFloat(props.origin.y) + i}%, ${props.position - i}px) translateY(-100%)`,
              zIndex: i
            }}
          >
            Index: {i}
          </div>

      }
    });
  };

  const animationShouldStop=(itemClass) =>{
    setAnimatingClasses (classes => {
      if (classes[itemClass]) return {...classes, [itemClass]:false}
      return classes
    })
  }
  const animationShouldStart=(itemClass, value = false) =>{
    setAnimatingClasses (classes => {
      return {...classes, [itemClass]:value}
    })
  }
  const handleUpdateRoad=(updateString) =>{
    console.log("Update Road", updateString)
    switch (updateString) {
      case 'clear':
        console.log("Clearing Road", updateString)
        props.roadClear()
        break;
      case 'startAnimateCrossing':
        animationShouldStart('yield-sign-crossing-on', true)
        animationShouldStart('yield-sign-crossing-on-after', true)
        break;
      case 'stopAnimatedCrossing':
        console.log("Crossing animation should stop")
        animationShouldStop('yield-sign-crossing-on')
        animationShouldStop('yield-sign-crossing-on-after') 
        break;
      case 'greenLightOn':
        console.log("Turn Green Light on")
        animationShouldStart('stoplight_green stayVisible', true)

        break;
      default:
        break;       
    }

  }
  return (
    <div
      className={`Road ${props.class} ${props.view}`}
      style={{
        perspective: `${1000}px`,
        perspectiveOrigin: `${props.origin.y} ${props.origin.x}`,
      }}
    >
      {
        // Show road segments from data.json
        props.roadSegments && props.roadSegments.map((segment, idx) => {
          return <div
            key={idx}
            className={`road-texture frame-${eventFrame} ${segment.class} ${segment.animatable ? '' : ''} ${eventFrame > 0 ? 'after-curve' : ''}`}
            style={{transform: `translate3d(0, -${getYOffset(segment.offsetSpeed)}%, 0)`}} />
        })
      }
        
        {
          props.curvedRoadData && props.curvedRoadData.zOffset < props.position && eventFrame < 54 && (
            <div className={`CurvedRoadEvent`}>
              <div className={`animated-road-pre frame-${eventFrame > 0 ? eventFrame-1 : 0}`} />
              <div className={`animated-road frame-${eventFrame}`} />
          </div>
          )
        }
        {
          props.roadOverlay && (eventFrame === 0 || eventFrame >= 54) && (
            <div className={`road-overlay ${eventFrame > 0 ? 'after-curve' : ''}`} />
          )
        }
      {
        [...props.roadItems, ...(props.roadEvents || []).map(e => Object.assign(e, {isRoadEvent: true}))]
          .sort((itemA, itemB) => {
            // sort by z index so they layer correctly
            return itemA.zOffset - itemB.zOffset;
          })
          .filter((item) => {
            // only render items we can see
            return (
              props.position - item.zOffset < (props.renderDistanceBehind || 3000) &&
              props.position - item.zOffset > (-(props.renderDistance) || -12000)
            );
          })
          .map((item, index) => {
            // actual item generation
            // replaces JSON item with current RoadObjectEditor item if applicable
            let editedItem = props.editedRoadObject.class === item.class ? props.editedRoadObject : null;
            if (editedItem) {
              editedItem.xOffset = editedItem.xOffset || item.xOffset
              editedItem.yOffset = editedItem.yOffset || item.yOffset
              editedItem.zOffset = editedItem.zOffset || item.zOffset
            }
            return (
              item.isRoadEvent !== true
              ? <div
                key={index}
                className={`road-object ${props.objectHighlight === item.class ? 'highlight' : ''} ${(editedItem || item).class}  ${props.didStopCorrectly && animatingClasses[(editedItem || item).class] === true ? 'animateCrossing' : ''} ${animatingClasses[(editedItem || item).class] === false ? 'motionFinished' : ''}`}
                style={{
                  transform: `translate3d(${(editedItem || item).xOffset}%, ${(editedItem || item).yOffset}%, ${props.position - (editedItem || item).zOffset}px)`,
                  zIndex: props.roadSegments.length + props.roadItems.length - index,
                }}
              />
                : !completedRoadEvents.some((e,i) => {                 
                  return props.roadEvents[i].type === item.type && !props.crossingFinished
                }) ?
                    <GenericRoadEvent 
                        position={props.position}
                        data={item.data}
                        type={item.type}
                        didStopCorrectly={props.didStopCorrectly}
                        // setMotionFinished={setMotionFinished}
                        xOffset={(editedItem || item).xOffset}
                        yOffset={(editedItem || item).yOffset}
                        zOffset={(editedItem || item).zOffset}
                        delay={(editedItem || item).delay}
                        finishPos={(editedItem || item).finishPos}
                        zIndex={props.roadSegments.length + props.roadItems.length - index}
                        setShowFail={props.setShowFail}
                        failedStop={props.failedStop}
                        completedRoadEvents={completedRoadEvents}
                        setCompletedRoadEvents={setCompletedRoadEvents}
                        setSideTrainVisible={props.setSideTrainVisible}
                        setLeftSideView = {props.setLeftSideView}
                        setRightSideView = {props.setRightSideView}
                        key={`generic-road-${index}`}
                        audioController={props.audioController}
                        crossingOver={props.crossingOver}
                        // enterZone={props.enterZone}
                        updateRoad={handleUpdateRoad}
                      />
                    : <></>
            );
          })
      }
      {showDistance &&
        <div
          className={`road-object ticker`}
          style={{
            transform: `translate3d(0%, 0%, 0px)`,
            zIndex: props.position,
          }}
        >
          {`Distance: ${props.distanceFromCrossing}ft`}
        </div>
      }

      {/* <div className="x" style={{ top: `${props.origin.x}` }} />
      <div className="y" style={{ left: `${props.origin.y}` }} />  */}
    </div>
  );
}